/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import {store} from './_store';
import VueRouter from 'vue-router'
import router from "./router/index";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import 'vue-awesome/icons'
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import moment from 'moment'

/* Register component with one of 2 methods */

import Icon from 'vue-awesome/components/Icon'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFilePdf,
  faFileImage,
  faFileExcel,
  faFilePowerpoint,
  faFileWord,
  faFileVideo,
  faFileArchive,
  faFileAlt,
  faFile,
  faTrashAlt,
  faUpload,
  faTasks
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faFilePdf,
  faFileImage,
  faFileExcel,
  faFilePowerpoint,
  faFileWord,
  faFileVideo,
  faFileArchive,
  faFileAlt,
  faFile,
  faTrashAlt,
  faUpload,
  faTasks
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

var PulseLoader = require('vue-spinner/src/PulseLoader.vue');

Vue.component('v-icon', Icon)

Vue.use(PaperDashboard);
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'));
Vue.prototype.moment = moment


/* eslint-disable no-new */
new Vue({
  components: {
    'PulseLoader': PulseLoader
  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");
